const { REACT_APP_ETHEREUM_RPC, REACT_APP_ETHEREUM_RPC_ID, REACT_APP_POLYGON_RPC } =
  process.env;

export const ethereumRPC = `${REACT_APP_ETHEREUM_RPC}${REACT_APP_ETHEREUM_RPC_ID}`;

export const polygonRPC = `${REACT_APP_POLYGON_RPC}`;
